var map = {
	"./pulpotomy_11@2x.png": 1779,
	"./pulpotomy_12@2x.png": 1780,
	"./pulpotomy_13@2x.png": 1781,
	"./pulpotomy_14@2x.png": 1782,
	"./pulpotomy_15@2x.png": 1783,
	"./pulpotomy_16@2x.png": 1784,
	"./pulpotomy_17@2x.png": 1785,
	"./pulpotomy_18@2x.png": 1786,
	"./pulpotomy_21@2x.png": 1787,
	"./pulpotomy_22@2x.png": 1788,
	"./pulpotomy_23@2x.png": 1789,
	"./pulpotomy_24@2x.png": 1790,
	"./pulpotomy_25@2x.png": 1791,
	"./pulpotomy_26@2x.png": 1792,
	"./pulpotomy_27@2x.png": 1793,
	"./pulpotomy_28@2x.png": 1794,
	"./pulpotomy_31@2x.png": 1795,
	"./pulpotomy_32@2x.png": 1796,
	"./pulpotomy_33@2x.png": 1797,
	"./pulpotomy_34@2x.png": 1798,
	"./pulpotomy_35@2x.png": 1799,
	"./pulpotomy_36@2x.png": 1800,
	"./pulpotomy_37@2x.png": 1801,
	"./pulpotomy_38@2x.png": 1802,
	"./pulpotomy_41@2x.png": 1803,
	"./pulpotomy_42@2x.png": 1804,
	"./pulpotomy_43@2x.png": 1805,
	"./pulpotomy_44@2x.png": 1806,
	"./pulpotomy_45@2x.png": 1807,
	"./pulpotomy_46@2x.png": 1808,
	"./pulpotomy_47@2x.png": 1809,
	"./pulpotomy_48@2x.png": 1810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4474;